import { useTranslation } from "react-i18next";
import { Call, User, People, Calendar } from "iconsax-react";
import { EmptyState } from "@/shared/components";
import type { EmergencyContact } from "../../types/personalSheet";
import ProfileDataRow from "../ProfileDataRow";

interface Props {
  contacts: EmergencyContact[];
}

export default function EmergencyContactsSection({ contacts }: Props) {
  const { t } = useTranslation("EmployeePortal");

  if (contacts.length === 0) {
    return <EmptyState noDataText={t("personalSheet.empty.emergency")} noDataHint={t("personalSheet.empty.emergencyHint")} compact />;
  }

  return (
    <div className="flex flex-col gap-6">
      {contacts.map(function renderContact(contact, index) {
        return (
          <div key={contact.id} className="flex flex-col">
            <p className="text-label-md content-base-primary mb-3">
              {t("personalSheet.contactNumber", { number: index + 1 })}
            </p>
            <ProfileDataRow icon={User} label={t("personalSheet.fields.contactName")} value={contact.contact_name} />
            <ProfileDataRow icon={People} label={t("personalSheet.fields.contactRelation")} value={contact.contact_relation ? t(`personalSheet.relationValues.${contact.contact_relation}`, { defaultValue: contact.contact_relation }) : null} />
            <ProfileDataRow icon={Call} label={t("personalSheet.fields.contactPhone")} value={contact.contact_phone} />
            {contact.birth_year != null && (
              <ProfileDataRow icon={Calendar} label={t("personalSheet.fields.birthYear")} value={String(contact.birth_year)} />
            )}
          </div>
        );
      })}
    </div>
  );
}
